import React, { useCallback } from 'react';

function PaginationNavigator({
    data,
    maxPagesToDisplay = 10,
    onPageChange
}) {
    
    const pageLinks = useCallback(
        renderPageLinks,
        [data, maxPagesToDisplay, onPageChange]
    )

    function renderPageLinks() {
        const halfMaxPages = Math.floor(maxPagesToDisplay * 0.5);
        const pageLinks = []

        for (let i = 0; i < data.totalPages && i < maxPagesToDisplay; i++) {
            if (data.totalPages > maxPagesToDisplay && data.pageIndex > halfMaxPages) {
                if ((i + data.pageIndex - halfMaxPages) < data.totalPages + 1) {
                    let pageNumber = i + data.pageIndex - halfMaxPages;
                    pageLinks.push(
                        <li key={pageNumber} className={`page-item ${pageNumber === data.pageIndex ? "active" : ""}`}>
                            <button className="page-link" onClick={() => onPageChange(pageNumber)}>{pageNumber}</button>
                        </li>
                    );
                }
            } else {
                pageLinks.push(
                    <li key={i + 1} className={`page-item ${i + 1 === data.pageIndex ? "active" : ""}`}>
                        <button className="page-link" onClick={() => onPageChange(i + 1)}>{i + 1}</button>
                    </li>
                );
            }
        }

        return pageLinks;
    }

    return (
        <div className="d-flex flex-fill justify-content-center py-3">
            <nav>
                <ul className="pagination">
                    <li className={`page-item ${data.hasPreviousPage ? "" : "disabled"}`}>
                        <button className="page-link" tabIndex="-1" onClick={() => onPageChange(data.pageIndex - 1)}>Previous</button>
                    </li>
                    {pageLinks()}
                    <li className={`page-item ${data.hasNextPage ? "" : "disabled"}`}>
                        <button className="page-link" onClick={() => onPageChange(data.pageIndex + 1)}>Next</button>
                    </li>
                </ul>
            </nav>
        </div>
    )
}

export default PaginationNavigator;